import { render } from "./PasswordReset.vue?vue&type=template&id=5b32731f&scoped=true&ts=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=5b32731f&lang=scss&scoped=true"

import exportComponent from "/app/apps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b32731f"]])

export default __exports__